import api from '../../utils/api';
import { ACCOUNT_ID_CONFIG, ACCOUNT_ID_CONFIG_UPDATE_ERROR } from '../constants/accountIdConfigTypes';
import { alertError, alertSuccess } from './alert';
import { setRetailerAccountIdConfig } from './retailer';

export const updateAccountIdConfig =
  ({ retailerId, supplierId, accountIdConfig }) =>
  async (dispatch) => {
    try {
      const response = await api.put(`/suppliers/${supplierId}/retailers/${retailerId}`, {
        account_id_config: accountIdConfig,
      });
      if (response.status === 200) {
        dispatch(alertSuccess('Succesfully updated account id config'));
        dispatch({ type: ACCOUNT_ID_CONFIG, payload: { response, account_id_config: accountIdConfig } });
        dispatch(setRetailerAccountIdConfig(accountIdConfig));
      } else {
        throw new Error(response);
      }
    } catch (e) {
      dispatch({ type: ACCOUNT_ID_CONFIG_UPDATE_ERROR });
      dispatch(alertError(e));
    }
  };
